/**
 * ./exercise8/Exercise8Intro.js
 * 
 * This module is similar with previous exercises. 
 * 
 */

import React, { useEffect, useState } from "react";
import "../exercise1/Exercise1Intro.css"; // Import the CSS file
import { useNavigate, useLocation } from "react-router-dom";
import IconBubble from "../components/IconBubble/IconBubble";
import Star2 from "../components/icons/star2.svg";
import { API_BASE_URL } from "../config";

const Exercise8Intro = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isWarmup = location.state?.isWarmup;
  const exerciseNumber = location.state?.exerciseNumber;  const [selectedLevel, setSelectedLevel] = useState(2);

  const [canStart, setCanStart] = useState(false);
  const [sunnyHTML, setSunnyHTML] = useState(
    `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
    Keep your eyes moving swiftly through the text to improve eye agility.
  </span>`
  );
  const [bubbleHeight, setBubbleHeight] = useState(100);
  const [userData, setUserData] = useState(null);
  const levels = [2, 4, 6, 8, 10];

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        const data = await response.json();
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const isLevelUnlocked = (levelNumber) => {
    if (!userData) return false;
    if ((8 < userData.numExercisesUnlocked) || (8 === userData.numExercisesUnlocked && levelNumber <= userData.currNumLevelsUnlocked)) {
      return true;
    }
    return false;
  };

  const handleLevelClick = (level) => {
    setSelectedLevel(level);
  };

  const handleStartClick = () => {
    if (isWarmup) {
      console.log(exerciseNumber)
      navigate("/Exercise8Warmup", {
                state: {
                  exerciseNumber: exerciseNumber,
                  isWarmup: true,
                  duration: 1.5
                }
              });
    } else {
        navigate("/exercise8workout");
    }

  };

  let handleNextNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
      Relax your eyes—attention should feel natural while maintaining <b>Rhythmic Breathing</b>.
    </span>`
    );

    setCanStart(true);
  };

  let handleNextClick = () => {
    setSunnyHTML(
      `<span style="color: #4B5161; font-family: 'Nunito', sans-serif; line-height: 1;">
      Distribute attention evenly across all words. Avoid focusing on single words.
    </span>`
    );
  };

  const renderButton = () => {
    if (canStart) {
      return (
        <button
          className="guidance-and-start-button"
          onClick={handleStartClick}
        >
          Start
        </button>
      );
    } else {
      return (
        <button
          className="guidance-and-start-button"
          onClick={
            sunnyHTML.includes("jump") ? handleNextClick : handleNextNextClick
          }
        >
          Next
        </button>
      );
    }
  };

  return (
    <div className="exercise1-intro-container">
      <div className="intro-content">
      </div>
      <div className="sunny-intro">
        <img src={Star2} alt="sunny" className="sunny" />
        <IconBubble
          width={620}
          height={bubbleHeight}
          HTML={sunnyHTML}
          color="FFFFFF"
          fontSize={25}
        />
      </div>
      <div className="bottom-buttons">
        <div></div>
        {renderButton()}
      </div>
    </div>
  );
};

export default Exercise8Intro;